/**
 * Educational Rates calculator
 *
 * @copyright 2018 Linguistica 360
 */

import { Script, injector } from '../shared/injector.js';

import $ from 'jquery';
import _delay from 'lodash/delay.js';
import { moneyFormat } from '../shared/utils.js';

const groups = [
    { from: 3, dk: 1.015 },
    { from: 10, dk: 1.01 },
    { from: 50, dk: 1.003 },
    { from: 100, dk: 1.001 },
];

function _calculate(json) {
    const type = $('[name=ec_type]:checked').val();

    let num = 0;
    const nums = {};
    const category = $('#ec_category').val(); // subscription category

    if (type === 'multi') {
        $('.ec_num').each(function () {
            const $element = $(this);
            const val = parseInt($element.val()) || 0;
            nums[$element.data('id')] = val;
            num += val;
        });
    } else {
        num = $('#ec_num').val() || 0; // number of subscriptions
        nums[$('[name=ec_type]:checked').data('id')] = num;
    }

    if (!num) {
        // if number of subscription is not specified, show empty output
        $('#ec_out').val(text);
        return;
    }

    // starting discount multipliers for different categories
    // school = 70%
    // college = 60%
    // study group = 50%
    let k = 50;
    if (category === 'school') k = 70;
    else if (category === 'college') k = 60;

    let result = 0;
    const min = 5;
    if (num < min) {
        result = 0;
        const text = `Educational rates are available for groups of ${min} or more students`;
        $('#ec_out').val(text);
        return;
    } else {
        result = 1 - k / 100;
        for (let i = 4; i < num; ++i) {
            let dk = 0;
            for (const g of groups) {
                if (g.from > i) break;
                else dk = g.dk;
            }

            result /= dk;
        }

        if (result < 0.1) result = 0.1;
    }

    const months = parseInt($('#ec_duration').val());

    // calculating price and price per student
    let totalPrice = 0;
    const prices = [];
    for (let uid in nums) {
        const pnum = nums[uid];

        let pricePerStudent = parseFloat(json[uid].price) * months;
        if (!result) pricePerStudent = Math.floor(pricePerStudent * 100) / 100;
        else pricePerStudent = Math.floor(pricePerStudent * result * 100) / 100;
        let price = pricePerStudent * pnum;
        prices.push(price);
        totalPrice += price;
    }

    let totalOrprice = 0;
    const orprices = [];
    for (let uid in nums) {
        const pnum = nums[uid];

        const orprice = parseFloat(json[uid].price) * months * pnum;
        orprices.push(orprice);
        totalOrprice += orprice;
    }

    let off = (totalOrprice - totalPrice) / totalOrprice;
    if (!result) off = 0;

    const pricePerStudent = moneyFormat(totalPrice / num);

    // formatting output
    let text = moneyFormat(off * 100) + '% OFF';
    text += '. Total subscription price: $' + moneyFormat(totalPrice) + ' USD';
    if (type !== 'multi') {
        text += ' ($' + moneyFormat(pricePerStudent) + ' USD per student)';
    }

    // showing the result of the calculation
    $('#ec_out').val(text);
}

// updating output when number of subscription changes
//
// if input event is available it will be used instead, it allows to not
// only catch when user inputs something, but also copy-paste events and
// others. basically when input content is changed the input event is fired
injector.injectClass(class extends Script {
    onLoad() {
        const json = JSON.parse($('#ec_json').val().replace(/'/g, '"'));

        $('[name=ec_type]').on('click', function () {
            if ($(this).val() === 'single') {
                $('#ec_num').parents('.element').show();
                $('.ec_num').parents('.element').hide();
            } else {
                $('#ec_num').parents('.element').hide();
                $('.ec_num').parents('.element').show();
            }

            _calculate(json);
        });

        $('#ec_type_single').trigger('click');

        $('#ec_num,.ec_num').on('input', function () {
            _calculate(json);
        });

        $('.education-calc').find('select').on('change', () => {
            _delay(() => { _calculate(json); }, 100);
        });

        $('#ec_duration').on('input', () => {
            _delay(() => { _calculate(json); }, 100);
        });
    }
}, ['educational-rates']);
